import React, {Component} from 'react';
import {Navigate} from 'react-router-dom';
import {LayoutSidebar} from "../../Layout";
import {LinesView} from "./panel_v11/LinesView";
import {useFicha21} from "../../context/UserModulesContext";
import {withRouterParams} from "../../utils/withRouterParams";

// Guard de /client/:id/lines (la vista de todas las líneas del Panel 2.1, card gtAL5axI). Sin
// `ficha21` la pantalla de líneas ES Monitoreo, así que ahí se redirige — la ruta no revela nada
// que el clásico no tenga.
//
// Hasta que llegan los módulos no se decide nada: redirigir con el flag todavía en false rebotaría
// a un usuario 2.1 a Monitoreo por un valor que no llegó (mismo patrón que ClientDefaultRoute).
function LinesGuard({clientId, history}) {
    const {ficha21, loaded} = useFicha21();

    if (!loaded) return null;
    if (!ficha21) return <Navigate to={`/client/${clientId}/monitoring`} replace/>;

    return <LinesView clientId={clientId} history={history}/>;
}

class ClientLinesComponent extends Component {
    render() {
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <LinesGuard
                    clientId={this.props.match.params.id}
                    history={this.props.history}
                />
            </div>
        );
    }
}

export default withRouterParams(ClientLinesComponent);
